import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';
import { Text } from '../../Text/Text';
import { CheckboxProps } from '../Checkbox';

type CheckboxLabelProps = Pick<CheckboxProps, 'disabled'> & {
    $truncateLabel: boolean;
};

export const CheckboxLabel = styled(Text).attrs({ variant: 'body' })<CheckboxLabelProps>`
    color: ${(props) => (props.disabled ? theme.colors.foreground.disabled : theme.colors.foreground.default)};
    ${(props) =>
        props.$truncateLabel
            ? `
                display: block;
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            `
            : null}
`;
